import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { AdminAudienceViewDto } from "@swagger/typescript-fetch-goflyer";
import { messages } from "../../../../../locales/messages";
import { ReviewChangeRequest } from "../../types";
import { CrSubmitter, resolveCrSubmitter } from "./resolveCrSubmitter";

export type {
  CrSubmitter,
  CrSubmitterKind,
} from "./resolveCrSubmitter";

export type CrSubmitterResolver = (cr: ReviewChangeRequest) => CrSubmitter;

export const useCrSubmitter = (
  audiences: AdminAudienceViewDto[] | undefined,
): CrSubmitterResolver => {
  const { t } = useTranslation();
  const adminLabel = t(messages.Admin());
  const anonymousLabel = t(messages.Anonymous_Reviewer());
  const unknownLabel = t(messages.Unknown());

  return useCallback(
    (cr: ReviewChangeRequest): CrSubmitter =>
      resolveCrSubmitter(cr, audiences, {
        admin: adminLabel,
        anonymous: anonymousLabel,
        unknown: unknownLabel,
      }),
    [audiences, adminLabel, anonymousLabel, unknownLabel],
  );
};
